<script setup lang="ts">
type TProps = {
  class?: string;
};
const props = defineProps<TProps>();
</script>

<template>
  <hr
    :class="
      cn('border-0 bg-interface-transparent-white w-full h-px', props.class)
    "
  />
</template>
